import formFadedOverlay from "./form-faded-overlay";

function toggleShowClassMobileFormOverlay() {
  const mobileOverlay = $(".js-mobile-faded-overlay");
  const fadedOverlay = $(".js-faded-overlay");

  if (mobileOverlay.length > 0 && $(window).width() < 768) {
    mobileOverlay.each(function () {
      let $this = $(this);
      formFadedOverlay($this);
    });
  }

  formFadedOverlay(fadedOverlay);
}

export default toggleShowClassMobileFormOverlay;
